import { ContentTag, provideComponent } from "scrivito"
import { ScrivitoImageWidgetList } from "scrivito/scrivito-image/ScrivitoImageWidgetList"

import { TestimonialWidget } from "./TestimonialWidgetClass"
import { TestimonialWidgetView } from "./ui/TestimonialWidgetView"

provideComponent(TestimonialWidget, ({ widget }) => {
  return (
    <TestimonialWidgetView
      testimony={widget.get("testimony")}
      testimonyLong={<ContentTag content={widget} attribute="testimonyLong" />}
      image={
        <ScrivitoImageWidgetList content={widget} attribute="imageWidgets" />
      }
      author={<ContentTag content={widget} attribute="author" />}
      authorPosition={
        <ContentTag content={widget} attribute="authorPosition" />
      }
      authorAffiliation={
        <ContentTag content={widget} attribute="authorAffiliation" />
      }
    />
  )
})
